'use client'

import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import {
  ArchiveBoxIcon,
  ArrowTopRightOnSquareIcon,
  DocumentDuplicateIcon,
  PencilIcon,
  TrashIcon,
} from '@heroicons/react/24/solid'

// Based on: https://headlessui.com/react/menu
function Options() {
  const items = [
    { name: 'Edit', disabled: false, icon: PencilIcon, divide: false },
    {
      name: 'Duplicate',
      disabled: false,
      icon: DocumentDuplicateIcon,
      divide: true,
    },
    { name: 'Archive', disabled: true, icon: ArchiveBoxIcon, divide: false },
    {
      name: 'Move',
      disabled: false,
      icon: ArrowTopRightOnSquareIcon,
      divide: true,
    },
    { name: 'Delete', disabled: false, icon: TrashIcon, divide: false },
  ]
  return (
    <Menu as="div">
      {/* relative gap-x-2 */}
      <MenuButton className="focus-custom flex w-24 h-7 rounded-md justify-center items-center border-custom">
        <div className="truncate">Options</div>
        <div className="px-1"></div>
        <ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
      </MenuButton>
      <MenuItems
        className="absolute w-fill origin-top-right rounded-md shadow-md shadow-violet-600 dark:shadow-violet-600 bg-background-light text-foreground-light dark:bg-background-dark dark:text-foreground-dark
          data-enter:transition data-enter:ease-out data-enter:duration-100
          data-enter-[from]:transform data-enter-[from]:opacity-0 data-enter-[from]:scale-95
          data-enter-[to]:transform data-enter-[to]:opacity-1000 data-enter-[to]:scale-100
          data-leave:transition data-leave:ease-in data-leave:duration-75
          data-leave-[from]:transform data-leave-[from]:opacity-100 data-leave-[from]:scale-100
          data-leave-[to]:transform data-leave-[to]:opacity-0 data-leave-[to]:scale-95"
        modal={false}
        transition
      >
        {/* @@TODO: Check if aria guidelines are followed! */}
        {/* @@TODO: modifying divide-XXX does not work under map. Divide is effective one level higher in hierarchy */}
        {items.map((item) => (
          <div
            className={`${
              item.divide ? 'divide-red-500' : 'divide-blue-500'
            } px-1 first:mt-1 last:mb-1`}
            key={item.name}
          >
            {/* @@TODO: Menu item cannot be selected by keyboard */}
            <MenuItem disabled={item.disabled}>
              <button
                type="button"
                disabled={item.disabled}
                className="disabled:opacity-50 disabled:cursor-not-allowed pe-8 group flex w-full items-center rounded-md px-2 py-2 data-focus:hover:bg-gray-200 dark:data-focus:hover:bg-gray-700"
              >
                <item.icon className="mx-2 h-4 w-4" aria-hidden="true" />
                {item.name}
              </button>
            </MenuItem>
            <div
              className={`${
                item.divide
                  ? 'bg-gray-200 dark:bg-gray-700'
                  : 'bg-background-light dark:bg-background-dark' /* hide divide */
              } mx-1 h-px`}
              key={item.name}
            />
          </div>
        ))}
      </MenuItems>
    </Menu>
  )
}

export default Options
